export default __webpack_public_path__ + "static/media/minus.74c05554.svg";